import { prettyDockHour } from '../formatters/format-dock-hours';

export const DOCK_HOURS_OPTIONS = [
  { label: prettyDockHour(360), value: 360 }, // 6:00
  { label: prettyDockHour(390), value: 390 }, // 6:30
  { label: prettyDockHour(420), value: 420 }, // 7:00
  { label: prettyDockHour(450), value: 450 }, // 7:30
  { label: prettyDockHour(480), value: 480 }, // 8:00
  { label: prettyDockHour(510), value: 510 }, // 8:30
  { label: prettyDockHour(540), value: 540 }, // 9:00
  { label: prettyDockHour(570), value: 570 }, // 9:30
  { label: prettyDockHour(600), value: 600 }, // 10:00
  { label: prettyDockHour(630), value: 630 }, // 10:30
  { label: prettyDockHour(660), value: 660 }, // 11:00
  { label: prettyDockHour(690), value: 690 }, // 11:30
  { label: prettyDockHour(720), value: 720 }, // 12:00
  { label: prettyDockHour(750), value: 750 }, // 12:30
  { label: prettyDockHour(780), value: 780 }, // 13:00
  { label: prettyDockHour(810), value: 810 }, // 13:30
  { label: prettyDockHour(840), value: 840 }, // 14:00
  { label: prettyDockHour(870), value: 870 }, // 14:30
  { label: prettyDockHour(900), value: 900 }, // 15:00
  { label: prettyDockHour(930), value: 930 }, // 15:30
  { label: prettyDockHour(960), value: 960 }, // 16:00
  { label: prettyDockHour(990), value: 990 }, // 16:30
  { label: prettyDockHour(1020), value: 1020 }, // 17:00
  { label: prettyDockHour(1050), value: 1050 }, // 17:30
  { label: prettyDockHour(1080), value: 1080 }, // 18:00
  { label: prettyDockHour(1110), value: 1110 }, // 18:30
  { label: prettyDockHour(1140), value: 1140 }, // 19:00
  { label: prettyDockHour(1170), value: 1170 }, // 19:30
  { label: prettyDockHour(1200), value: 1200 }, // 20:00
  { label: prettyDockHour(1230), value: 1230 }, // 20:30
  { label: prettyDockHour(1260), value: 1260 }, // 21:00
];
